// Reine Hilfen für die Backup-Anzeige - ohne React und ohne Importe (per Node testbar).

// Megabyte mit deutschem Komma, eine Nachkommastelle.
export const mbText = (bytes) => {
  const zahl = Number(bytes);
  if (!Number.isFinite(zahl) || zahl <= 0) return '0,0 MB';
  return (zahl / (1024 * 1024)).toFixed(1).replace('.', ',') + ' MB';
};

// Endung der heruntergeladenen Sicherung: verschlüsselt -> .zip.enc
export const sicherungEndung = (headerWert) => (String(headerWert) === '1' ? '.zip.enc' : '.zip');

// Rot melden, sobald es nach 09:00 Uhr ist und die Nacht kein Datum von heute hat.
export const nachtFehlt = (letzteNachtDatum, jetzt) => {
  const zeit = jetzt instanceof Date ? jetzt : new Date();
  if (zeit.getHours() < 9) return false;
  const heute = `${zeit.getFullYear()}-${String(zeit.getMonth() + 1).padStart(2, '0')}-${String(zeit.getDate()).padStart(2, '0')}`;
  return letzteNachtDatum !== heute;
};

// Dateiname aus dem Sicherungs-Schlüssel (nacht/2026/09/timenyzer_nacht_....zip.enc).
export const dateinameAus = (schluessel) => String(schluessel || '').split('/').pop() || 'sicherung.zip.enc';
